import {createContext, useContext, useState} from 'react';
import UserDetailModal from '../../../../components/UserComponents/UserDetailModal';
import ContentDetailModal from '../../../../designComponents/modals/ContentDetailModal';
import {createPortal} from 'react-dom';
import {useQueryClient} from 'react-query';

const ManagementDashboardContext = createContext();

/**운영 대시보드에서 팝업되는 모달을 관리하기 위한 컨텍스트 프로바이더 */
export default function ManagementDashboardModalProvider({ children }) {
    const [modalOpen, setModalOpen] = useState(false);
    const [modalContentType, setModalContentType] = useState(null); //'userDetail', 'reportDetail',
    const [modalProps, setModalProps] = useState(null); // 모달에 전달할 props
    const [invalidateQueryKey, setInvalidateQueryKey] = useState(null);
    const queryClient = useQueryClient();

    const openModal = (type, modalProps, queryKey) => {
        setModalContentType(type);
        setInvalidateQueryKey(queryKey);
        setModalOpen(true);
        setModalProps(modalProps);
    };

    const closeModal = () => {
        setModalOpen(false);
        setModalContentType(null);
        setInvalidateQueryKey(null);
        setModalProps(null);
    };

    const invalidateQueries = () => {
        if (invalidateQueryKey) {
            queryClient.invalidateQueries(invalidateQueryKey);
        }
    };
    const ctxValue = { openModal, closeModal, modalOpen, modalContentType, modalProps, setModalProps, invalidateQueries };
    return <ManagementDashboardContext.Provider value={ctxValue}>{children}</ManagementDashboardContext.Provider>;
}

export const useModal = () => {
    const ctx = useContext(ManagementDashboardContext);
    if (!ctx) throw new Error('useModal must be used within a ManagementDashboardModalProvider');
    return ctx;
};

export function ManagementsDashboardModalPortal() {
    const [modalPortalContainer] = useState(() => document.querySelector('#managements-dashboard-modal-root'));
    const { modalContentType, modalProps, invalidateQueries } = useModal();
    if (!modalPortalContainer) return null; // 컨테이너가 없으면 렌더하지 않음

    const ModalContent = () => {
        if (!modalContentType) return null;
        switch (modalContentType) {
            case 'userDetail':
                return <UserDetailModal {...modalProps} updateLists={invalidateQueries} />; /**유저,신고받은 유저 정보를 보여주는 모달 */
            case 'reportContent':
                return <ContentDetailModal {...modalProps} />; /**신고된 컨텐츠 정보를 보여주는 모달 */
            default:
                return null;
        }
    };
    return createPortal(<ModalContent />, modalPortalContainer);
}
